// ----------------------------------------------------------------------------
// Section: FAQs
// ----------------------------------------------------------------------------
//
// FAQs Section
// - Based on the Accordion pattern
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/accordion/accordion';

// Styles
import './_technical-features.scss';
import 'sections/fit-guide/fit-guide';
import 'sections/fit-cards/fit-cards';

